<template>
    <div class="single-select-menu">
        <div class="option-list">
            <div
                v-for="item in filteredItems"
                :key="item[itemValue]"
                class="option"
                :class="{ selected: isSelected(item) }"
                @click="selectItem(item)"
            >
                <span class="item-text" :style="{ color: item.active ? 'black' : 'rgba(141, 153, 146, 1)' }">
                    {{ t(item[itemText]) }}
                </span>
                <i class="far fa-check check-icon" v-if="isSelected(item)"></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        filteredItems: { type: Array, required: true },
        itemText: { type: String, required: true },
        itemValue: { type: String, required: true },
        selectedItem: { type: [String, Number], default: null },
    },
    computed: {
        selectedSet() {
            return this.selectedItem;
        },
    },
    methods: {
        isSelected(item) {
            return this.selectedSet === item[this.itemValue];
        },
        selectItem(item) {
            this.$emit("select", item[this.itemValue]);
            this.$parent.isOpen = false;
        },
    },
};
</script>

<style scoped>
.single-select-menu {
    display: flex;
    flex-direction: column;
}

.option-list {
    max-height: 200px;
    overflow-y: auto;
}

.option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
    cursor: pointer;
    font-size: 14px;
    border-radius: 4px;
    white-space: nowrap;
}

.option:hover {
    background-color: #f5f5f5;
}

.item-text {
    flex: 1;
    font-weight: 500;
}

.check-icon {
    color: #ff0000;
    font-size: 14px;
}
</style>
